import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { formatCurrency } from '@instamenu/formatters';
import { useLocale } from '@instamenu/context-i18n';
import clsx from 'clsx';

import {
  tooltipStyle,
  swatch,
  value,
  header,
  body,
  legendItem,
  groupStyle,
  groupAdjacent,
} from './Tooltip.css';
import { TooltipType } from './DailySales';

const swatches = [
  ['#34AC68', '#91D9B0'],
  ['#797979', '#C5C4C4'],
];
const horizontalMargin = 16;

export default function Tooltip({ tooltip }: { tooltip: TooltipType }) {
  const { i18n } = useLocale();
  const ref = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  useLayoutEffect(() => {
    if (!tooltip || !ref.current) return;
    const { boundingBox } = tooltip;

    setPosition({
      top: boundingBox.y - ref.current.clientHeight - 20,
      left: Math.max(
        horizontalMargin,
        Math.min(
          window.innerWidth - ref.current.clientWidth - horizontalMargin,
          boundingBox.x - ref.current.clientWidth / 2,
        ),
      ),
    });
  }, [tooltip]);
  if (!tooltip) return null;

  return createPortal(
    <div data-id="daily-sales-tooltip" className={tooltipStyle} style={position} ref={ref}>
      {[...tooltip.data].reverse().map((group, i) => (
        <div key={i} className={clsx(groupStyle, i > 0 && groupAdjacent)}>
          <div className={header}>{tooltip.labels[i]}</div>
          <div className={body}>
            <div className={legendItem}>
              <div className={swatch} style={{ background: swatches[i][0] }} />
              <div>
                <div>{i18n.t('salesSummary.dailySales.netSales')}</div>
                <div className={value}>{formatCurrency(group[tooltip.index].netSales)}</div>
              </div>
            </div>
            <div className={legendItem}>
              <div className={swatch} style={{ background: swatches[i][1] }} />
              <div>
                <div>{i18n.t('salesSummary.dailySales.tips')}</div>
                <div className={value}>{formatCurrency(group[tooltip.index].tips)}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>,
    document.body,
  );
}
